"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActivityType = void 0;
var ActivityType;
(function (ActivityType) {
    ActivityType["Accept"] = "Accept";
    ActivityType["Add"] = "Add";
    ActivityType["Announce"] = "Announce";
    ActivityType["Arrive"] = "Arrive";
    ActivityType["Block"] = "Block";
    ActivityType["Create"] = "Create";
    ActivityType["Delete"] = "Delete";
    ActivityType["Dislike"] = "Dislike";
    ActivityType["Flag"] = "Flag";
    ActivityType["Follow"] = "Follow";
    ActivityType["Ignore"] = "Ignore";
    ActivityType["Invite"] = "Invite";
    ActivityType["Join"] = "Join";
    ActivityType["Leave"] = "Leave";
    ActivityType["Like"] = "Like";
    ActivityType["Listen"] = "Listen";
    ActivityType["Move"] = "Move";
    ActivityType["Offer"] = "Offer";
    ActivityType["Question"] = "Question";
    ActivityType["Reject"] = "Reject";
    ActivityType["Read"] = "Read";
    ActivityType["Remove"] = "Remove";
    ActivityType["TentativeReject"] = "TentativeReject";
    ActivityType["TentativeAccept"] = "TentativeAccept";
    ActivityType["Travel"] = "Travel";
    ActivityType["Undo"] = "Undo";
    ActivityType["Update"] = "Update";
    ActivityType["View"] = "View";
    ActivityType["ChangeCargoReadyDate"] = "ChangeCargoReadyDate";
    ActivityType["ChangeCargoReadyDateAggregation"] = "ChangeCargoReadyDateAggregation";
    ActivityType["ChangeEstimatedTimeDeparture"] = "ChangeEstimatedTimeDeparture";
    ActivityType["ChangeEstimatedTimeDepartureAggregation"] = "ChangeEstimatedTimeDepartureAggregation";
    ActivityType["ChangeContainerYardCutOffDate"] = "ChangeContainerYardCutOffDate";
    ActivityType["UpdatePartnerBookingStatus"] = "UpdatePartnerBookingStatus";
    ActivityType["ChangePickup"] = "ChangePickup";
    ActivityType["ChangePickupAggregation"] = "ChangePickupAggregation";
    ActivityType["ChangeArrival"] = "ChangeArrival";
    ActivityType["ChangeArrivalAggregation"] = "ChangeArrivalAggregation";
    ActivityType["ChangeDelivery"] = "ChangeDelivery";
    ActivityType["ChangeDeliveryAggregation"] = "ChangeDeliveryAggregation";
    ActivityType["CargoRollover"] = "CargoRollover";
    ActivityType["MainCarriageDelay"] = "MainCarriageDelay";
    ActivityType["MainCarriageDelayDeparture"] = "MainCarriageDelayDeparture";
    ActivityType["MainCarriageDelayArrival"] = "MainCarriageDelayArrival";
    ActivityType["UpdateCustomsStatus"] = "UpdateCustomsStatus";
    ActivityType["ChangeContainerDischarge"] = "ChangeContainerDischarge";
    ActivityType["ChangeContainerEmptyReturn"] = "ChangeContainerEmptyReturn";
    ActivityType["ChangeDemDetRate"] = "ChangeDemDetRate";
    ActivityType["ChangeDetentionRate"] = "ChangeDetentionRate";
    ActivityType["ChangeCombinedDemDetRate"] = "ChangeCombinedDemDetRate";
    ActivityType["ChangeDemurrageRate"] = "ChangeDemurrageRate";
    ActivityType["ChangeContainerGateOut"] = "ChangeContainerGateOut";
    ActivityType["ApproveWorkflow"] = "ApproveWorkflow";
    ActivityType["RejectWorkflow"] = "RejectWorkflow";
    ActivityType["BookingConfirmedByCarrier"] = "BookingConfirmedByCarrier";
    ActivityType["CreateBooking"] = "CreateBooking";
    ActivityType["CancelBooking"] = "CancelBooking";
    ActivityType["ChangeAssignee"] = "ChangeAssignee";
    ActivityType["ChangeOriginOperationsManager"] = "ChangeOriginOperationsManager";
    ActivityType["ChangeDestinationOperationsManager"] = "ChangeDestinationOperationsManager";
    ActivityType["UpdateShipment"] = "UpdateShipment";
    ActivityType["ChangeEstimatedTimeDepartureTS"] = "ChangeEstimatedTimeDepartureTS";
    ActivityType["ChangeArrivalTS"] = "ChangeArrivalTS";
    ActivityType["MainCarriageDelayTS"] = "MainCarriageDelayTS";
    ActivityType["MainCarriageDelayArrivalTS"] = "MainCarriageDelayArrivalTS";
    ActivityType["MainCarriageDelayDepartureTS"] = "MainCarriageDelayDepartureTS";
    ActivityType["TransShipmentMissedVesselRisk"] = "TransShipmentMissedVesselRisk";
    ActivityType["ReassuranceInsight"] = "ReassuranceInsight";
    ActivityType["DeviationRiskInsight"] = "DeviationRiskInsight";
    ActivityType["DeviationInsight"] = "DeviationInsight";
    ActivityType["UpdateInsight"] = "UpdateInsight";
    ActivityType["MessageInsight"] = "MessageInsight";
    ActivityType["CreateInsight"] = "CreateInsight";
    ActivityType["BookingFeedV1"] = "booking";
    ActivityType["CreateShipment"] = "CreateShipment";
    ActivityType["BookingRequestFeedV1"] = "bookingRequest";
    ActivityType["CompanyUserUpdateFeedV1"] = "companyUserUpdate";
    ActivityType["CustomsDecisionUpdateFeedV1"] = "customsDecisionUpdate";
    ActivityType["CustomsStatusUpdateFeedV1"] = "customsStatusUpdate";
    ActivityType["DocumentUploadFeedV1"] = "documentUpload";
    ActivityType["ManualQuoteFeedV1"] = "manualQuote";
    ActivityType["ManualQuoteDeclineFeedV1"] = "manualQuoteDecline";
    ActivityType["MessageFeedV1"] = "message";
    ActivityType["ProductUpdateFeedV1"] = "productUpdate";
    ActivityType["ShipmentUpdateFeedV1"] = "shipmentUpdate";
    ActivityType["SubscriptionFeedV1"] = "subscription";
    ActivityType["SubscriptionAddFeedV1"] = "subscriptionAdded";
    ActivityType["SubscriptionRemoveFeedV1"] = "subscriptionRemoved";
    ActivityType["TransportPlanUpdatedFeedV1"] = "transportPlanUpdated";
    ActivityType["BookingUpdateFeedV1"] = "bookingUpdate";
    ActivityType["ChangeOperationManagerFeedV1"] = "changeOperationManager";
    ActivityType["ChangeOriginOperationManagerFeedV1"] = "changeOriginOperationManager";
    ActivityType["CommunicationFeedV1"] = "communication";
    ActivityType["RateUpdateAppliedFeedV1"] = "rateUpdateApplied";
    ActivityType["ShipmentContractUpdatedFeedV1"] = "shipmentContractUpdated";
    ActivityType["ReportCreated"] = "ReportCreated";
})(ActivityType || (exports.ActivityType = ActivityType = {}));
//# sourceMappingURL=activity.type.js.map